//coded by Narain on (10/09/2024)

import {
  FooterContainer,
  FooterText
} from '../styles/ChatWindow';

const Footer = () => (
  <>
    <FooterContainer>
      <FooterText variant="body2">
        Proprietary Product of Vegas Connit. For more information, reach out to contact@vegascg.com
      </FooterText>
    </FooterContainer>
  </>  
);

export default Footer;
